export interface SpinnerProps {
  size?: number;
  color?: string;
  /** Screen-reader label. Set to null inside a button that already has text. */
  label?: string | null;
}

export function Spinner({ size = 18, color = 'var(--accent)', label = 'Loading' }: SpinnerProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label ?? undefined}
      aria-hidden={label ? undefined : true}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        flex: '0 0 auto',
        border: `2px solid color-mix(in srgb, ${color} 25%, transparent)`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: 'tabi-spin 700ms linear infinite',
      }}
    />
  );
}
